import { TimelineMax } from 'gsap';
import Swiper from 'swiper';
import checkZero from '@/scripts/utils/lead-zero';

export default function () {
  function createSVG() {
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    $(svg).attr('preserveAspectRatio', 'none');
    $(svg).attr('fill', '#ffffff');
    $(svg).attr('viewBox', '0 0 100 150');
    return svg;
  }

  function createStripeRect(svg, positionX, width) {
    const rectElement = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
    $(rectElement).attr('class', 'stripe');
    $(rectElement).attr('x', positionX + '%');
    $(rectElement).attr('width', width + 0.15 + '%');
    $(rectElement).attr('height', '100%');

    $(svg).append(rectElement);
  }

  $('[data-type="cover-slider"]').each((i, el) => {
    const $this = $(el);
    const tl = new TimelineMax();
    const $stripesContainer = $this.find('[data-type="stripes"]');
    const stripesSVG = createSVG();
    let stripesCount = 3;
    if ($(document).width() > 1440) {
      stripesCount = 6;
    }

    const width = 100 / stripesCount;
    for (let j = 0; j < stripesCount; j++) {
      const posX = width * j;
      createStripeRect(stripesSVG, posX, width);
    }
    $stripesContainer.append(stripesSVG);

    const $stripes = $this.find('.stripe');
    const $btnPrev = $this.find('[data-type="button-prev"]');
    const $btnNext = $this.find('[data-type="button-next"]');

    const paginationConfig = {
      el: $this.find('[data-type="pagination"]'),
      clickable: true,
      renderBullet(index, className) {
        const slideNumber = checkZero(index + 1);
        return `<span class="${className}">${slideNumber}</span>`;
      },
    };
    if ($this.hasClass('cover-slider_article')) {
      paginationConfig.dynamicBullets = true;
      paginationConfig.dynamicMainBullets = 4;
    }
    const swiperConfig = {
      virtualTranslate: true,
      loop: true,
      effect: 'fade',
      speed: 1000,
      autoHeight: false,
      slidesPerView: 1,
      navigation: {
        nextEl: $btnNext,
        prevEl: $btnPrev,
      },
      pagination: paginationConfig,
      on: {
        init: () => {
          tl
            .to($stripesContainer, 0.01, { zIndex: 3 })
            .staggerFromTo($stripes, 1, { y: '0%', z: 0 }, {
              y: '100%',
              z: 0,
              delay: 0.5,
            }, 0.2)
            .to($stripesContainer, 0.01, { zIndex: 0 });
        },
      },
    };

    const $slider = $this.find('[data-type="cover-slider-slides"]');

    if (!$slider) return;

    function blockNavBtns() {
      $btnPrev.prop('disabled', true);
      $btnNext.prop('disabled', true);
    }

    function unblockNavBtns() {
      $btnPrev.prop('disabled', false);
      $btnNext.prop('disabled', false);
    }

    const sliderSwiper = new Swiper($slider, swiperConfig);

    if ($stripes.length) {
      sliderSwiper.on('transitionStart', () => {
        blockNavBtns();
        tl
          .to($stripesContainer, 0.01, { zIndex: 3 })
          .staggerFromTo($stripes, 0.5, { y: '-100%', z: 0 }, {
            y: '0%',
            z: 0,
          }, 0.13);
      });
      sliderSwiper.on('transitionEnd', () => {
        tl
          .staggerFromTo($stripes, 0.5, { y: '0%', z: 0 }, {
            y: '100%',
            z: 0,
          }, 0.13)
          .to($stripesContainer, 0.01, { zIndex: 0 });
        unblockNavBtns();
      });
    }
  });
}




// WEBPACK FOOTER //
// ./scripts/blocks/cover-slider.js